import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Optimized selector hook for InventoryHeader component
 * Uses shallow comparison to prevent unnecessary re-renders
 *
 * @returns Selected header state and actions
 */
export const useInventoryHeaderState = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      isEditMode: state.isEditMode,
      tab: state.tab,
      packType: state.packType,
    }))
  );
};

/**
 * Optimized selector hook for header actions
 * Separates actions from state
 *
 * @returns Header actions
 */
export const useInventoryHeaderActions = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      changeTab: state.changeTab,
      setChangesModalData: state.setChangesModalData,
    }))
  );
};
